import { formatDateMMDDYY } from 'helpers/dateHelper';

export const getCreditCardOffer = todayContainerModules => {
  const creditCardModule = todayContainerModules.find(
    module => module.module === 'Suggested Credit Card',
  );
  if (!isOfferAvailable(creditCardModule)) return null;

  return {
    offerTitle: 'Credit Cards',
    clickType: 'Credit Cards',
    offerSubtitle: formatOfferCount(creditCardModule),
    badgeLabel: 'APPROVAL ODDS',
    extraDetails: `${creditCardModule?.additionalData?.approvalOddsCount?.key?.toUpperCase()} (${
      creditCardModule?.additionalData?.approvalOddsCount?.count
    })`,
    offerUrl: '/offers?vertical=CREDIT_CARD',
  };
};

export const getPersonalLoanOffer = todayContainerModules => {
  const personalLoanModule = todayContainerModules.find(
    module => module.module === 'Personal Loan Prequal',
  );
  if (!isOfferAvailable(personalLoanModule)) return null;

  return {
    offerTitle: 'Personal Loans',
    clickType: 'Personal Loans',
    offerSubtitle: formatOfferCount(personalLoanModule),
    badgeLabel: 'BEST APR',
    extraDetails: formatAPR(personalLoanModule),
    offerUrl: '/offers?vertical=PERSONAL_LOAN',
  };
};

export const getHomeLoanOffer = () => {
  return {
    offerTitle: 'Home Loans',
    clickType: 'Home Loans',
    offerSubtitle: 'Check your offers',
    badgeLabel: 'LOW RATES',
    extraDetails: `Last updated: ${formatDateMMDDYY(new Date())}`,
    offerUrl: '/offers?vertical=HOME_LOAN&tab=new',
  };
};

export const getAutoLoanOffer = todayContainerModules => {
  const autoLoanModule = todayContainerModules.find(
    module => module.module === 'AUTO_LOAN',
  );
  if (!isOfferAvailable(autoLoanModule)) return null;

  return {
    offerTitle: 'Auto Loans',
    clickType: 'Auto Loans',
    offerSubtitle: formatOfferCount(autoLoanModule),
    badgeLabel: 'BEST APR',
    extraDetails: formatAPR(autoLoanModule),
    offerUrl: '/offers?vertical=AUTO_LOAN',
  };
};

const formatAPR = module => {
  return module?.additionalData?.bestAPR
    ? `${module?.additionalData?.bestAPR}%`
    : null;
};

const formatOfferCount = module => {
  const count = module?.additionalData?.totalReturnedOfferCount ?? 0;
  return count > 0 ? `${count} available offer${count > 1 ? 's' : ''}` : null;
};

const isOfferAvailable = module =>
  module?.additionalData?.totalReturnedOfferCount > 0;
